module.exports = __webpack_public_path__ + "img/金徽章.dfaca01a.svg";